import { EntityType } from '@vendasta/automata';
import { ColumnType, ColumnWidth, Pinned, TableDefinition } from '@vendasta/va-filter2-table';
import { DateCellComponent } from '../../shared/table-cells/date-cell.component';
import { CurrentlyWaitingFiltersService } from './currently-waiting-filters.service';
import { EndRunCellComponent } from './end-run-cell.component';
import { buildVATableEntityDisplayColumns, getActivityTableId } from '../../shared/entities';

export const tableDefinitionFactory = (filterService: CurrentlyWaitingFiltersService, entityType: EntityType) => {
  const tableDefinition = CURRENTLY_WAITING_TABLE_DEF;
  tableDefinition.filters = filterService.filters;
  tableDefinition.id = getActivityTableId(entityType);
  tableDefinition.columns = buildVATableEntityDisplayColumns(entityType).concat(standardColumns);
  return tableDefinition;
};

const standardColumns = [
  {
    id: 'startedProcessing',
    displayName: 'AUTOMATIONS.EDITOR.CURRENTLY_WAITING.STARTED_WAITING',
    type: ColumnType.COLUMN_TYPE_STRING,
    cellComponent: DateCellComponent,
    field: 'activity.startedProcessing',
  },
  {
    id: 'end-run',
    displayName: '',
    cellComponent: EndRunCellComponent,
    width: ColumnWidth.WIDTH_NARROW,
    pinned: Pinned.PINNED_RIGHT,
  },
];

export const CURRENTLY_WAITING_TABLE_DEF: TableDefinition = {
  id: 'currentWaiting',
  labels: {
    noResults: 'AUTOMATIONS.ACTIVITY.TABLE.NO_RESULTS',
    cancel: 'COMMON.ACTION_LABELS.CANCEL',
    none: 'COMMON.ACTION_LABELS.NONE_LABEL',
    update: 'COMMON.ACTION_LABELS.UPDATE',
    sortBy: '',
    thenSortBy: '',
    addAnotherSortColumn: '',
    chooseColumnToSortBy: '',
    columnSorting: {
      date: {
        ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.EARLIEST_TO_LATEST',
        descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.LATEST_TO_EARLIEST',
      },
      number: {
        ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS._1_TO_9',
        descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS._9_TO_1',
      },
      string: {
        ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.A_TO_Z',
        descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.Z_TO_A',
      },
      default: {
        ascending: 'ascending',
        descending: 'descending',
      },
    },
    export: {
      buttonText: '',
      buttonTooltipBeforeCount: '',
      buttonTooltipAfterCount: '',
    },
  },
  options: {
    selectableRows: false,
    csvExportEnabled: false,
    tableTitle: 'AUTOMATIONS.TABLE.FILTERS.FILTERS',
    pageSizeOptions: [10, 25, 50],
    defaultPageSize: 10,
  },
  columns: [],
};
